import { FamilyStep, StepSelectionType } from "@domain/product/monitoring/family/family-step";
import { FamilyStepOption } from "@domain/product/monitoring/family/family-step-option";
import { FamilyVariantMode } from "@project/monitoring/monitoring-family-wizard.utils";
import type { OptionDisplay } from "@project/monitoring/option-display.service";

export function getSelectedFamilyOption(
  selectedFamily?: OptionDisplay,
  selectedFamilyVariant?: OptionDisplay,
): OptionDisplay | undefined {
  if (selectedFamily?.familyVariant?.variant.mode === FamilyVariantMode.NO_OPTIONS) return undefined;

  return selectedFamilyVariant ?? selectedFamily;
}

export function createFamilyVariantStep(step: FamilyStep): FamilyStep {
  const selectionType = Object.values(StepSelectionType).find((type) => type === step.stepSelectionType);
  return new FamilyStep(step.options, selectionType ?? StepSelectionType.PICK1);
}

export function getConfigurationOptionIdentifier(familyName: string | undefined, option: FamilyStepOption): string {
  const normalizedFamilyName = familyName?.trim();
  const familyNamePrefix = normalizedFamilyName ? `${normalizedFamilyName}|` : "";
  const groupName = option.groupName?.trim();

  if (groupName) return `${familyNamePrefix}${groupName}`;
  if (option.devices.length === 1) return `${familyNamePrefix}${String(option.devices[0])}`;
  if (!option.devices.length) return familyNamePrefix;

  const devices = option.devices
    .map((device) => String(device))
    .sort()
    .join(",");
  return `${familyNamePrefix}${devices}`;
}
